import cx from 'classnames';
import type { FieldProps } from 'formik';
import { Field, Formik } from 'formik';
import { useContext, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { createUserTrace } from '../../api/Optimise';
import { OnboardingContext } from '../../context/OnboardingContext';
import LoopSpinner from '../../ui/LoopSpinner';
import { RadioWrapper } from '../../ui/Styled';
import yesNoToBool from '../../utils/yesNoToBool';

const ElectricVehicleContainer = () => {
  const navigate = useNavigate();
  const { hasEv, setHasEv, setProgressPercentage } = useContext(OnboardingContext);

  const validationSchema = Yup.object({
    hasEv: Yup.mixed().oneOf(['yes', 'no']).required(),
  });

  const onSubmit = ({ hasEv }: { hasEv: string }) => {
    setHasEv(hasEv);
    void createUserTrace('Electric Vehicle', {
      additional_information: {
        has_ev: yesNoToBool(hasEv),
      },
    });
    void navigate('/onboarding/equipment-details');
  };

  useEffect(() => {
    setProgressPercentage(60);
  }, [setProgressPercentage]);

  return (
    <>
      <h1 className="mb-3">Do you have an electric vehicle?</h1>
      <div>
        <>
          <p>If you have one or more electric vehicle, please let us know here.</p>
          <div className="text-left mt-5">
            <Formik
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              initialValues={{
                hasEv: hasEv || 'no',
              }}
              validateOnChange
            >
              {({ handleSubmit, isValid, isSubmitting, values }) => (
                <Form onSubmit={handleSubmit}>
                  <Field name="hasEv">
                    {({ field, meta }: FieldProps<string>) => (
                      <RadioWrapper
                        className={cx({
                          selected: field.value === 'no',
                        })}
                      >
                        <Form.Check
                          type="radio"
                          name={field.name}
                          id="radio-less-than"
                          value={'no'}
                          label="No, I don’t have an electric vehicle"
                          onChange={field.onChange}
                          onBlur={field.onBlur}
                          className={cx({ error: !!meta.error })}
                        />
                      </RadioWrapper>
                    )}
                  </Field>
                  <Field name="hasEv">
                    {({ field, meta }: FieldProps<string>) => (
                      <RadioWrapper
                        className={cx({
                          selected: field.value === 'yes',
                        })}
                      >
                        <Form.Check
                          type="radio"
                          name={field.name}
                          id="more-less-than"
                          value={'yes'}
                          label="Yes, I have at least one electric vehicle"
                          onChange={field.onChange}
                          onBlur={field.onBlur}
                          className={cx({ error: !!meta.error })}
                        />
                      </RadioWrapper>
                    )}
                  </Field>
                  <Form.Group>
                    {!isSubmitting ? (
                      <Button
                        variant="primary"
                        disabled={!isValid || isSubmitting || !values.hasEv}
                        className="w-100"
                        type="submit"
                      >
                        Continue
                      </Button>
                    ) : (
                      <LoopSpinner />
                    )}
                  </Form.Group>
                </Form>
              )}
            </Formik>
          </div>
        </>
      </div>
    </>
  );
};

export default ElectricVehicleContainer;
